module.exports = __webpack_public_path__ + "static/media/icon_user_settings.76659915.svg";